import React, { PureComponent } from 'react'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'
import { Checkbox } from 'antd'
import validate from './validation/validation'
import _ from 'lodash'
import { bizNumbersService } from '../../_services'

export default class NumberForm extends PureComponent {
    handleSubmit = (data, setSubmitting) => {
        // this.props.handleClose()

        const { id } = data

        if (id) {
            bizNumbersService
                .updateBizNumber(data)
                .then(res => {
                    this.props.handleClose()
                    this.props.onSubmitRefresh()
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            bizNumbersService
                .addBizNumber(data)
                .then(res => {
                    this.props.handleClose()
                    this.props.onSubmitRefresh()
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    onChkChange = (e, form) => {
        form.setFieldValue('receiveSms', e.target.checked)
    }

    render() {
        const empty = {
            name: '',
            mobile: '',
            receiveSms: false,
        }

        const selectedBiznumber = this.props.data
        const initialValues = _.isEmpty(selectedBiznumber)
            ? empty
            : selectedBiznumber

        return (
            <Formik
                initialValues={initialValues}
                validate={validate()}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        this.handleSubmit(values, setSubmitting)
                    }, 400)
                }}
            >
                {numberForm => (
                    <Form onSubmit={numberForm.handleSubmit}>
                        <div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Bizness Name:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="name"
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                placeholder="Bizness Name"
                                                onChange={
                                                    numberForm.handleChange
                                                }
                                                onBlur={numberForm.handleBlur}
                                                value={numberForm.values.name}
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Contact Number:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="mobile"
                                                name="mobile"
                                                type="text"
                                                className="form-control"
                                                placeholder="Contact Number"
                                                onChange={
                                                    numberForm.handleChange
                                                }
                                                onBlur={numberForm.handleBlur}
                                                value={numberForm.values.mobile}
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="mobile" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Checkbox
                                                onChange={e =>
                                                    this.onChkChange(
                                                        e,
                                                        numberForm
                                                    )
                                                }
                                                name="receiveSms"
                                                checked={numberForm.values.receiveSms}
                                            >
                                                Receive message
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm-w m-2"
                                    data-dismiss="modal"
                                    onClick={this.props.handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-success pull-left btn-sm-w m-2"
                                    disabled={numberForm.isSubmitting}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}
